export const Tractor_listing = (t: any, i18n: any) => [
  {
    Header: t("Farm"),
    accessor: "farm_name",
  },
  {
    Header: t("Field"),
    accessor: "field_name",
  },
  { Header: t("MachineryCode"), accessor: "machinery_code" },

  {
    Header: t("MachineryCategory"),
    accessor:
      i18n.language === "en" ? "machinery_category" : "machinery_category_ar",
  },
  {
    Header: t("Supplier"),
    accessor: "supplier_name",
  },
  {
    Header: t("AssetRef.No."),
    accessor: "asset_ref_no",
  },

  // {
  // 	Header: t("Location"),
  // 	accessor: "location",
  // },
  {
    Header: t("MachineryOwnership"),
    accessor:
      i18n.language === "en" ? "machinery_ownership" : "machinery_ownership_ar",
  },
];
